"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const updateControlsArrayByPath_1 = __importDefault(require("./updateControlsArrayByPath"));
const updatePageControlsByInfo = ({ // eslint-disable-line
pages, controlInfo, dataToUpdate, }) => {
    const { context: { pageId }, path } = controlInfo;
    if (!pageId) {
        throw new Error('No page id on context');
    }
    const page = pages[pageId];
    if (!page) {
        throw new Error(`No page with id ${pageId} was not found`);
    }
    const { controls, updatedControls } = (0, updateControlsArrayByPath_1.default)({
        controls: page.controls || [],
        path,
        dataToUpdate,
    });
    const newPages = Object.assign(Object.assign({}, pages), { [pageId]: Object.assign(Object.assign({ isDynamicLoadingEnabled: false }, page), { controls }) });
    return { pages: newPages, updatedPageId: pageId, updatedControls };
};
exports.default = updatePageControlsByInfo;
